//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.Electrical.js";
import "../Routing/Routing.StockDefinition.js";
let d=[[[0,"CrossSectionType",1,0],[0,"Gauge",1,0],[0,"Height",1,0],[0,"LinearDensity",1,0],[0,"MinBendRadius",1,0],[0,"Width",1,0],[0,"WireType",1,0]],[],[]];
SPLM.Routing.Electrical.ElectricalStockDefinition = class extends SPLM.Routing.StockDefinition{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.Electrical.ElectricalStockDefinition";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.Electrical.ElectricalStockDefinition.SectionType = Object.freeze({
    "Circular" : "Circular", "Rectangular" : "Rectangular"});

export default SPLM;